import { render, staticRenderFns } from "./FatTable.vue?vue&type=template&id=151ad6f7&scoped=true"
import script from "./FatTable.vue?vue&type=script&lang=js"
export * from "./FatTable.vue?vue&type=script&lang=js"
import style0 from "./FatTable.vue?vue&type=style&index=0&id=151ad6f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ad6f7",
  null
  
)

export default component.exports